import clsx from "clsx";
import React from "react";

export default function Skeleton({
  className,
  numberOfSkeletons = 2,
  ...restProps
}) {
  return (
    <>
      {Array.from({ length: numberOfSkeletons }).map((_, index) => (
        <div
          key={index}
          className={clsx(className, "tw-bg-neutral-300/40 tw-animate-pulse")}
          {...restProps}
        />
      ))}
    </>
  );
}
